var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "48px",
    viewBox: "0 0 44 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pdf_icon copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.5830116,38.5482625 C35.5830116,39.3637066 34.9158301,40.030888 34.1003861,40.030888 L1.48262548,40.030888 C0.667181467,40.030888 -6.03961325e-13,39.3637066 -6.03961325e-13,38.5482625 L-6.03961325e-13,23.7220077 C-6.03961325e-13,22.9065637 0.667181467,22.2393822 1.48262548,22.2393822 L34.1003861,22.2393822 C34.9158301,22.2393822 35.5830116,22.9065637 35.5830116,23.7220077 L35.5830116,38.5482625 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.4%",
    y: "-16.9%",
    width: "116.9%",
    height: "133.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.615686275   0 0 0 0 0.654901961   0 0 0 0 0.666666667  0 0 0 0.26 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.615686275   0 0 0 0 0.654901961   0 0 0 0 0.666666667  0 0 0 0.08 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.058824 0 0 0 0 0.086275 0 0 0 0 0.101961 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IT-Nonstop/About_1300",
    transform: "translate(-64.000000, -1856.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download_docs_buttons",
    transform: "translate(40.000000, 1832.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S_Components/Download_document_button",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf_icon-copy",
    transform: "translate(26.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8957529,0 C7.26486486,0 5.93050193,1.33436293 5.93050193,2.96525097 L5.93050193,44.4787645 C5.93050193,46.1096525 7.26486486,47.4440154 8.8957529,47.4440154 L38.5482625,47.4440154 C40.1791506,47.4440154 41.5135135,46.1096525 41.5135135,44.4787645 L41.5135135,11.8610039 L29.6525097,0 L8.8957529,0 Z",
    id: "Path",
    fill: "#F0503C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6177606,11.8610039 L41.5135135,11.8610039 L29.6525097,0 L29.6525097,8.8957529 C29.6525097,10.5266409 30.9868726,11.8610039 32.6177606,11.8610039 Z",
    id: "Path",
    fill: "#B62715"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "41.5135135 20.7567568 32.6177606 11.8610039 41.5135135 11.8610039"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-3)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.393822, 27.243243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0689420849,0.848061776 C0.0689420849,0.456648649 0.377328185,0.0296525097 0.874007722,0.0296525097 L3.61241699,0.0296525097 C5.15434749,0.0296525097 6.54208494,1.06155985 6.54208494,3.03938224 C6.54208494,4.91342085 5.15434749,5.95718919 3.61241699,5.95718919 L1.63311197,5.95718919 L1.63311197,7.5228417 C1.63311197,8.04472587 1.30100386,8.33976834 0.874007722,8.33976834 C0.482594595,8.33976834 0.0689420849,8.04472587 0.0689420849,7.5228417 L0.0689420849,0.848061776 L0.0689420849,0.848061776 Z M1.63311197,1.52265637 L1.63311197,4.47604633 L3.61241699,4.47604633 C4.40710425,4.47604633 5.03573745,3.77476448 5.03573745,3.03938224 C5.03573745,2.21059459 4.40710425,1.52265637 3.61241699,1.52265637 L1.63311197,1.52265637 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86387645,8.33976834 C8.47246332,8.33976834 8.04546718,8.12627027 8.04546718,7.60586873 L8.04546718,0.871783784 C8.04546718,0.44627027 8.47246332,0.136401544 8.86387645,0.136401544 L11.5785637,0.136401544 C16.9960772,0.136401544 16.8774672,8.33976834 11.6853127,8.33976834 L8.86387645,8.33976834 L8.86387645,8.33976834 Z M9.61111969,1.58344402 L9.61111969,6.89420849 L11.5785637,6.89420849 C14.7795521,6.89420849 14.9218842,1.58344402 11.5785637,1.58344402 L9.61111969,1.58344402 L9.61111969,1.58344402 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7989498,1.67833205 L18.7989498,3.56274903 L21.8220232,3.56274903 C22.2490193,3.56274903 22.6760154,3.98974517 22.6760154,4.40339768 C22.6760154,4.79481081 22.2490193,5.11505792 21.8220232,5.11505792 L18.7989498,5.11505792 L18.7989498,7.6043861 C18.7989498,8.01952124 18.5039073,8.33828571 18.0887722,8.33828571 C17.566888,8.33828571 17.2481236,8.01952124 17.2481236,7.6043861 L17.2481236,0.870301158 C17.2481236,0.444787645 17.5683707,0.134918919 18.0887722,0.134918919 L22.2505019,0.134918919 C22.7723861,0.134918919 23.0807722,0.444787645 23.0807722,0.870301158 C23.0807722,1.24985328 22.7723861,1.67684942 22.2505019,1.67684942 L18.7989498,1.67684942 L18.7989498,1.67833205 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M34.1003861,40.030888 L5.93050193,40.030888 L5.93050193,41.5135135 L34.1003861,41.5135135 C34.9158301,41.5135135 35.5830116,40.846332 35.5830116,40.030888 L35.5830116,38.5482625 C35.5830116,39.3637066 34.9158301,40.030888 34.1003861,40.030888 Z",
    id: "Path",
    fillRule: "nonzero"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIco);
export default __webpack_public_path__ + "static/media/pdf-ico.cbdecd38.svg";
export { ForwardRef as ReactComponent };